<template>
    <div class="block wjhg" id="wjhg">
        <div class="itemTitBox wow animated bounceInRight">
            <p class="big">往届回顾</p>
            <p class="small"> PREVIOUS REVIEW</p>
        </div>
        <div class="wow animated bounceInLeft">
            <div class="imgList wow animated flipInY">
                <div
                    class="img"
                    v-for="(item, index) in dataJson.past"
                    :key="index"
                >
                    <img :src="item" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import dataJson from "../assets/index.json";
export default {
    data() {
        return {
            dataJson,
        };
    },
};
</script>
<style>
@media (max-width: 900px) {
  #wjhg .imgList .img  {
    width: 700px !important;
  }
}
</style>
<style lang="less" scoped>
@import url("../views/index.less");
#wjhg {
    margin-top: 22px;
    position: relative;
    width: 100%;
    .imgList {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 0 120px ;
        margin-top: 36px;
        
        .img {
            width: 228px;
            transition: all 0.6s;
            margin-bottom: 14px;
            img {
                width: 100%;
            }
            &:hover {
                transform: scale(1.05);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/wjhg.vue